import * as Typings from '../typings'
import { BRAND_LIST, Languages } from '../../typings'

const ThailandLocale: Typings.LocaleType = {
  REGION: Typings.RegionGroupNames.SOUTH_EAST_ASIA,
  CODE: 'th',

  LONG_NAME: 'Thailand',
  SHORT_NAME: 'TH',

  DISPLAY_COUNTRY: 'Thailand',

  LANGUAGES: {
    EN: 'en',
    TH: 'th',
  },

  [BRAND_LIST.UQ]: {
    [Languages.EN]: {
      LANGUAGE_CODE: 'en',
      DISPLAY_NAME: 'Thailand (English)',
      TERMS_OF_USE_URL:
        'https://faq-th.uniqlo.com/pkb_Home_UQ_TH?id=kA37F000000HZ7j&l=en_US',
      PRIVACY_POLICY_URL:
        'https://faq-th.uniqlo.com/pkb_Home_UQ_TH?id=kA37F000000HZ7Z&l=en_US',
      HOME_PAGE_URL: 'https://uniqlo.com/th/en/',
      CONTACT_US_URL: 'https://faq-th.uniqlo.com/pkb_Home_UQ_TH?l=en_US',
    },
    [Languages.TH]: {
      LANGUAGE_CODE: 'th',
      DISPLAY_NAME: 'ไทย',
      TERMS_OF_USE_URL:
        'https://faq-th.uniqlo.com/pkb_Home_UQ_TH?id=kA37F000000HZ7o&l=th',
      PRIVACY_POLICY_URL:
        'https://faq-th.uniqlo.com/pkb_Home_UQ_TH?id=kA37F000000HZ7e&l=th',
      HOME_PAGE_URL: 'https://www.uniqlo.com/th/th/',
      CONTACT_US_URL: 'https://faq-th.uniqlo.com/pkb_Home_UQ_TH?l=th',
    },
  },

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 15.87,
    INITIAL_LONGITUDE: 100.9925,
    INITIAL_ZOOM: 5,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  MAP_URL: 'https://www.uniqlo.com/th/shop/',
  // MAP_MOBILE_URL: '',

  TERMS_OF_USE_URL: 'https://www.uniqlo.com',
  PRIVACY_POLICY_URL: 'https://www.uniqlo.com',

  POSTCODE_FORMAT: /[0-9]{5}/g,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  AM_FORMAT: ' AM',
  PM_FORMAT: ' PM',

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
  CMS_ENABLED: {
    [BRAND_LIST.UQ]: true,
  },
}

export default ThailandLocale
